export const getWindow = (defaultValue = {}) => (typeof window !== 'undefined' ? window : defaultValue);
export const getDocument = (defaultValue = {}) => (typeof document !== 'undefined' ? document : defaultValue);
